import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GET_SUBORDER } from 'src/apiService/apiDeclaration';
import truck from 'src/assets/truck.png';
import { showDate2 } from 'src/constants';

const OrderCard = ({ order }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [subOrder, setSubOrder] = useState([]);

  const getSubOrders = async () => {
    setLoading(true);
    try {
      let { data } = await GET_SUBORDER(order?._id);
      setSubOrder(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSubOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      onClick={() => navigate('/order-details', { state: order })}
      sx={{
        width: '100%',
        background: 'linear-gradient(135deg, #4ed3a2, #32b1d1, #5684ff, #a450e5, #4ed3a2)',
        borderRadius: '20px',
        fontSize: {
          md: '22px',
          xs: '16px',
        },
        color: '#fff',
        p: 4,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box
          sx={{
            width: {
              md: '60%',
              xs: '100%',
            },
          }}
        >
          <Box sx={{ mb: 1 }}>
            <Typography variant="h3" color={'#acd629'}>
              {t('navMenu.order')} #{order?.orderNumber}
            </Typography>
          </Box>
          <Box sx={{ pb: 1, width: 'max-content' }}>
            {t('common.status')}: {t(`labels.${order.status[order.status.length - 1].status}`)}
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {order?.paymentMethod && (
              <>
                <Box>
                  {t('common.totalAmount')}: ${order.totalAmount}
                </Box>
                <Box>
                  {t('customerPage.paymentMethod')}: {t(`labels.${order.paymentMethod}`)}
                </Box>
              </>
            )}
          </Box>
        </Box>
        <Box
          sx={{
            height: '150px',
            width: '300px',
            display: {
              md: 'block',
              xs: 'none',
            },
          }}
        >
          <img
            className="blob"
            src={truck}
            style={{ width: '100%', color: 'white', height: '100%', objectFit: 'cover', objectPosition: 'center' }}
            alt="truck"
          />
        </Box>
      </Box>
      <Typography variant="h3" sx={{ my: 2, color: '#acd629' }}>
        {t('orderDetailsPage.subOrders')}
      </Typography>
      <Grid
        container
        xs={12}
        sx={{
          px: 2,
        }}
      >
        {subOrder.length === 0 ? (
          <Box
            sx={{
              width: '100%',
              height: '200px',
              fontSize: '22px',
              color: '#fff',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {loading ? <CircularProgress /> : 'Something Went Wrong'}
          </Box>
        ) : (
          subOrder.map((sub, index) => (
            <Grid
              key={index}
              item
              xs={12}
              sm={6}
              md={4}
              sx={{ display: 'flex', flexDirection: 'column', gap: 1, pb: 2 }}
            >
              <Typography variant="h4" sx={{}}>
                {t('orderDetailsPage.subOrder')} #{sub.subOrderNumber}
              </Typography>
              {order.status[order.status.length - 1].status === 'PAYMENT_RECEIVED' && (
                <Box>
                  {t('common.status')}: {t(`labels.${sub.status[sub.status.length - 1].status}`)}
                </Box>
              )}
              <Grid container xs={12}>
                <Grid item xs={12}>
                  {t('dashboard.volumeOfConcrete')}: {sub.volumeOfConcrete}m³
                </Grid>
                <Grid item xs={12}>
                  {t('dashboard.dosage')}: {sub.dosage}
                </Grid>
              </Grid>
              <Grid item xs={12}>
                {t('dashboard.deliveryDate')}: {showDate2(sub.deliveryDate)}
              </Grid>
              <Grid item xs={12}>
                {t('dashboard.timeOfDelivery')}: {t(`labels.${sub.timeOfDelivery}`)}
              </Grid>
              <Grid container xs={12}>
                {t('common.deliveryAddress')}:{' '}
                {sub.streetNumber + ' ' + sub.streetAddress + ' ' + sub.municipality + ' ' + sub.city}
              </Grid>
            </Grid>
          ))
        )}
      </Grid>
    </Box>
  );
};

export default OrderCard;
